import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import "../../cssfiles/homepage.css";
import Menu from "@mui/material/Menu";
import { createTheme, ThemeProvider } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { ThemeContext } from "../Homepage";
import { useContext } from "react";
import { format } from "date-fns";
import {
  MenuItem,
  Select,
  FormControl,
  Button,
  Popover,
  Typography,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import {
  updatedateselection,
  updatedateselection_sdate_edate,
  updateselecteddates_dashboard,
  updateDynamicObject,
  updateKeyValue,
} from "../../store/mainpage_data";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { DateRange } from "react-date-range";

const timePeriodOptions = [
  "Today",
  "Yesterday",
  "This Week",
  "Last Week",
  "This Month",
  "Last Month",
  /*"This Year",
  "Last Year",
  "Last 24 hours",
  "Last 7 days",
  "Last 30 days",*/
  "Custom",
];

function Year() {
  const dispatch = useDispatch();
  const { theme } = useContext(ThemeContext);

  const [selectedValue, setSelectedValue] = useState("");
  const spanRef = React.useRef();
  const [label, setLabel] = useState("This Year");
  const [customDateRange, setCustomDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isDateRangeConfirmed, setIsDateRangeConfirmed] = useState(false);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (timePeriodOptions[timePeriodOptions.length - 1] !== "Custom") {
      timePeriodOptions.pop();
    }
    setSelectedValue(value);
    setIsSelectOpen(false);

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const currentDate = now.getDate();
    const dayOfWeek = now.getDay();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const last24Hours = new Date(now);
    last24Hours.setHours(now.getHours() - 24);

    const currDay = now.getDay();
    const lastSunday = new Date(now);
    lastSunday.setDate(now.getDate() - currDay - 7);
    const lastSaturday = new Date(lastSunday);
    lastSaturday.setDate(lastSunday.getDate() + 6);

    const thisSunday = new Date(now);
    thisSunday.setDate(now.getDate() - currDay);

    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(now.getDate() - 7);

    const thirtyDaysAgo = new Date(now);
    thirtyDaysAgo.setDate(now.getDate() - 30);

    const lastYear = now.getFullYear() - 1;

    const formatDate = (date) => {
      return date.toString();
    };

    var startdate;
    var enddate;
    var startdate;
    var enddate;
    var startdate_dashboard;
    var enddate_dashboard;
    var enddate;
    var sdate;
    var edate;
    var disableyear = false;

    if (value !== "Custom") {
      switch (event.target.value) {
        case "This Year":
          startdate_dashboard = new Date(currentYear, 0, 1); // January 1st of the current year
          enddate_dashboard = new Date(currentYear, 11, 31, 23, 59, 59, 999); // December 31st of the current year
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0).toString();
          edate = now.toString();
          disableyear = true;
          break;
        case "Last Year":
          const lastYear = currentYear - 1;
          startdate_dashboard = new Date(lastYear, 0, 1);
          enddate_dashboard = new Date(lastYear, 11, 31, 23, 59, 59, 999);
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(lastYear, 0, 1, 0, 0, 0, 0).toString();
          edate = new Date(lastYear, 11, 31, 23, 59, 59, 999).toString();
          disableyear = true;
          break;
        case "This Month":
          startdate_dashboard = new Date(currentYear, currentMonth, 1); // First day of current month
          enddate_dashboard = new Date(
            currentYear,
            currentMonth + 1,
            0,
            23,
            59,
            59,
            999
          ); // Last day of current month
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            now.getFullYear(),
            now.getMonth(),
            1,
            0,
            0,
            0,
            0
          ).toString();
          edate = now.toString();

          break;
        case "Last Month":
          const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
          const yearForLastMonth =
            currentMonth === 0 ? currentYear - 1 : currentYear;
          startdate_dashboard = new Date(yearForLastMonth, lastMonth, 1);
          enddate_dashboard = new Date(
            yearForLastMonth,
            lastMonth + 1,
            0,
            23,
            59,
            59,
            999
          );
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            now.getFullYear(),
            now.getMonth() - 1,
            1,
            0,
            0,
            0,
            0
          ).toString();
          edate = new Date(
            now.getFullYear(),
            now.getMonth(),
            0,
            23,
            59,
            59,
            999
          ).toString();
          break;
        case "This Week":
          const startOfWeek = new Date(now);
          startOfWeek.setDate(currentDate - dayOfWeek); // Sunday of the current week
          startOfWeek.setHours(0, 0, 0, 0);
          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday of the current week
          endOfWeek.setHours(23, 59, 59, 999);
          startdate_dashboard = startOfWeek;
          enddate_dashboard = endOfWeek;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            thisSunday.getFullYear(),
            thisSunday.getMonth(),
            thisSunday.getDate(),
            0,
            0,
            0,
            0
          ).toString();
          edate = now.toString();
          break;
        /*const startOfWeek = new Date(now);
          startOfWeek.setDate(currentDate - dayOfWeek); // Sunday of the current week
          startOfWeek.setHours(0, 0, 0, 0);
          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday of the current week
          endOfWeek.setHours(23, 59, 59, 999);
          startdate_dashboard = startOfWeek;
          enddate_dashboard = endOfWeek;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          break;*/
        case "Last Week":
          const startOfLastWeek = new Date(now);
          startOfLastWeek.setDate(currentDate - dayOfWeek - 7); // Start of last week
          startOfLastWeek.setHours(0, 0, 0, 0);
          const endOfLastWeek = new Date(startOfLastWeek);
          endOfLastWeek.setDate(startOfLastWeek.getDate() + 6); // End of last week
          endOfLastWeek.setHours(23, 59, 59, 999);
          startdate_dashboard = startOfLastWeek;
          enddate_dashboard = endOfLastWeek;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            lastSunday.getFullYear(),
            lastSunday.getMonth(),
            lastSunday.getDate(),
            0,
            0,
            0,
            0
          ).toString();
          edate = new Date(
            lastSaturday.getFullYear(),
            lastSaturday.getMonth(),
            lastSaturday.getDate(),
            23,
            59,
            59,
            999
          ).toString();
          break;
        case "Today":
          startdate = new Date(now);
          startdate.setHours(0, 0, 0, 0); // Start of today
          enddate = new Date(now);
          enddate.setHours(23, 59, 59, 999); // End of today
          startdate_dashboard = startdate;
          enddate_dashboard = enddate;
          const intialdate = new Date();
          const secondszero = new Date(intialdate.setHours(0, 0, 0));
          var todayepoc = Math.floor(secondszero / 1000);
          var todatendepoc = todayepoc + 23 * 60 * 60 + 59 * 60 + 59;
          startdate = todayepoc;
          enddate = todatendepoc;
          sdate = new Date(now.setHours(0, 0, 0, 0)).toString();
          edate = new Date().toString();

          break;
        case "Yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(currentDate - 1);
          startdate = new Date(yesterday);
          startdate.setHours(0, 0, 0, 0); // Start of yesterday
          enddate = new Date(yesterday);
          enddate.setHours(23, 59, 59, 999); // End of yesterday
          startdate_dashboard = startdate;
          enddate_dashboard = enddate;
          const intialdatey = new Date();
          const secondszeroy = new Date(intialdatey.setHours(0, 0, 0));
          var todayepoc = Math.floor(secondszeroy / 1000) - 24 * 60 * 60;
          var todatendepoc = todayepoc + 23 * 60 * 60 + 59 * 60 + 59;

          startdate = todayepoc;
          enddate = todatendepoc;
          sdate = new Date(
            yesterday.getFullYear(),
            yesterday.getMonth(),
            yesterday.getDate(),
            0,
            0,
            0,
            0
          ).toString();
          edate = new Date(
            yesterday.getFullYear(),
            yesterday.getMonth(),
            yesterday.getDate(),
            23,
            59,
            59,
            999
          ).toString();

          break;
        case "Last 24 hours":
          const end24 = new Date();
          const start24 = new Date();
          start24.setHours(start24.getHours() - 24); // 24 hours ago
          startdate_dashboard = start24;
          enddate_dashboard = end24;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = last24Hours.toString();
          edate = now.toString();

          break;
        case "Last 7 days":
          const end7Days = new Date();
          const start7Days = new Date();
          start7Days.setDate(currentDate - 7); // 7 days ago
          startdate_dashboard = start7Days;
          enddate_dashboard = end7Days;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            sevenDaysAgo.getFullYear(),
            sevenDaysAgo.getMonth(),
            sevenDaysAgo.getDate(),
            0,
            0,
            0,
            0
          ).toString();
          edate = now.toString();

          break;
        case "Last 30 days":
          const end30Days = new Date();
          const start30Days = new Date();
          start30Days.setDate(currentDate - 30); // 30 days ago
          startdate_dashboard = start30Days;
          enddate_dashboard = end30Days;
          startdate_dashboard = formatDate(startdate_dashboard);
          enddate_dashboard = formatDate(enddate_dashboard);
          sdate = new Date(
            thirtyDaysAgo.getFullYear(),
            thirtyDaysAgo.getMonth(),
            thirtyDaysAgo.getDate(),
            0,
            0,
            0,
            0
          ).toString();
          edate = now.toString();
          break;
      }
      if (disableyear != true) {
        dispatch(
          updateselecteddates_dashboard({
            selectedstartdate_dashboard: startdate_dashboard,
            selectedenddate_dashboard: enddate_dashboard,
          })
        );
      }

      /*dispatch(
        updateselecteddates_dashboard({
          selectedstartdate_dashboard: startdate_dashboard,
          selectedenddate_dashboard: enddate_dashboard,
        })
      );*/
      //if(event.target.value === 'Today' || event.target.value === 'Yesterday'){
      dispatch(
        updatedateselection_sdate_edate({
          selectedstartdate: startdate,
          selectedenddate: enddate,
          selectedrepstartdate: sdate,
          selectedrependdate: edate,
        })
      );
      //}
      dispatch(updatedateselection(event.target.value));
    }
  };

  const handleMenuItemClick = (event, period) => {
    if (period === "Custom") {
      setAnchorEl(spanRef.current);
    } else {
      setAnchorEl(null);
    }
    setSelectedValue(period);
  };

  const handleDateChange = (item) => {
    setCustomDateRange([item.selection]);

    const { startDate, endDate } = item.selection;

    // Only confirm if both start and end dates are selected
    if (startDate && endDate && startDate !== endDate) {
      setIsDateRangeConfirmed(true);
    } else {
      setIsDateRangeConfirmed(false);
    }
  };

  function convertEndDate(startDate, endDate) {
    // Create Date objects from the input strings
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Subtract one day from the end date
    end.setDate(end.getDate());
    end.setHours(23, 59, 59); // Set time to 23:59:59

    // Format the end date as a string
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    const formattedEndDate = end.toLocaleDateString("en-US", options);

    return formattedEndDate;
  }

  const handleCustomDateConfirm = () => {
    const start = format(customDateRange[0].startDate, "MM/dd/yyyy");
    const end = format(customDateRange[0].endDate, "MM/dd/yyyy");
    const customLabel = `${start} - ${end}`;
    timePeriodOptions.push(customLabel);
    var sdateupdate = customDateRange[0].startDate;
    var edateupdate = customDateRange[0].endDate;
    const modifiedEnd = convertEndDate(sdateupdate, edateupdate);

    var dateObj = new Date(edateupdate);
    dateObj.setDate(dateObj.getDate() + 1);
    edateupdate = dateObj.toString();

    setSelectedValue(customLabel);
    setAnchorEl(null);
    dispatch(
      updatedateselection_sdate_edate({
        selectedstartdate: sdateupdate,
        selectedenddate: modifiedEnd,
        selectedrepstartdate: sdateupdate,
        selectedrependdate: modifiedEnd,
      })
    );
    dispatch(
      updateselecteddates_dashboard({
        selectedstartdate_dashboard: sdateupdate,
        selectedenddate_dashboard: modifiedEnd,
      })
    );
    dispatch(updatedateselection("Custom"));
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleSelectOpen = () => {
    if (timePeriodOptions[timePeriodOptions.length - 1] !== "Custom") {
      timePeriodOptions.pop();
    }
    setIsSelectOpen(true);
  };

  useEffect(() => {
    var startdate;
    var enddate;
    setSelectedValue("Today");
    const intialdate = new Date();
    const secondszero = new Date(intialdate.setHours(0, 0, 0));
    var todayepoc = Math.floor(secondszero / 1000);
    var todatendepoc = todayepoc + 23 * 60 * 60 + 59 * 60 + 59;
    startdate = todayepoc;
    enddate = todatendepoc;
    dispatch(
      updatedateselection_sdate_edate({
        selectedstartdate: startdate,
        selectedenddate: enddate,
      })
    );
    dispatch(updatedateselection("Today"));
  }, []);

  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );

  function handleDateRange(dateselected) {
    var startdaterange = dateselected.startDate;
    var enddaterange = dateselected.endDate;
    dispatch(
      updatedateselection_sdate_edate({
        selectedstartdate: startdaterange,
        selectedenddate: enddaterange,
      })
    );
    dispatch(updatedateselection("Custom"));
  }
  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  };

  const handleChange = (event, parameter, parameterdates) => {
    if (parameter == "Custom") {
      setSelectedValue("Custom");
      setLabel("");
      var startdaterange = parameterdates.startDate.toString();
      var enddaterange = parameterdates.endDate.toString();
      dispatch(
        updatedateselection_sdate_edate({
          selectedstartdate: startdaterange,
          selectedenddate: enddaterange,
        })
      );
      dispatch(updatedateselection("Custom"));
    } else {
      setSelectedValue(event.target.value);
      setLabel("");
      var startdate;
      var enddate;
      switch (event.target.value) {
        case "This Year":
          startdate = "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Dec 31 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "Last Year":
          startdate = "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Dec 31 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "This Month":
          startdate = "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Tue Jan 31 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "Last Month":
          startdate = "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Tue Jan 31 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "This Week":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 21 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "Last Week":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 21 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "Today":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 15 2023 23:59:59 GMT+0530 (India Standard Time)";
          break;
        case "Yesterday":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 15 2023 23:59:59 GMT+0530 (India Standard Time)";
          break;
        case "Last 24 hours":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 15 2023 23:59:59 GMT+0530 (India Standard Time)";
          break;
        case "Last 7 days":
          startdate = "Sun Jan 15 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Sun Jan 21 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
        case "Last 30 days":
          startdate = "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)";
          enddate = "Tue Jan 30 2023 00:00:00 GMT+0530 (India Standard Time)";
          break;
      }
      dispatch(
        updatedateselection_sdate_edate({
          selectedstartdate: startdate,
          selectedenddate: enddate,
        })
      );
      if (event.target.value == "Last 7 days") {
        dispatch(updatedateselection("This Week"));
      } else if (event.target.value == "Last 24 hours") {
        dispatch(updatedateselection("Today"));
      } else if (event.target.value == "Last 30 days") {
        dispatch(updatedateselection("This Month"));
      } else {
        dispatch(updatedateselection(event.target.value));
      }
    }
  };

  return (
    <div>
      <FormControl>
        {/*<InputLabel id="yearSelect"  shrink={false} sx={{textAlign:"left",marginRight:"6px",fontSize:'12px', fontFamily:'Roboto',fontWeight:400,marginTop:"-6px",color:"var(--GreyVariation_2)" }}>{label}</InputLabel>*/}
        <Select
          //name="yearSelect" id="yearSelect" labelId="yearSelect" inputlabel="year"
          value={selectedValue}
          onChange={handleSelectChange}
          onOpen={handleSelectOpen}
          open={isSelectOpen}
          onClose={() => {
            setIsSelectOpen(false);
          }}
          displayEmpty
          defaultValue="Custom"
          sx={{
            border: 0,
            width: "222.35px",
            height: "40px",
            bgcolor: "var(--SecondaryBackground)",
            color: "var(--GreyVariation_2)",
            fontSize: "14px",
            fontFamily: "Roboto",
            fontWeight: 400,
            textAlign: "left",
            borderRadius: 0,
            marginRight: "16px",
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            "& .MuiOutlinedInput-notchedOutline ": {
              width: "122.35px",
              height: "40px",
              border: 0,
              padding: 0,
            },
            "& .MuiInputLabel-root": {
              display: "none",
              legend: "none",
              paddingTop: "3px",
            },
          }}
          InputLabelProps={{ shrink: false }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
                borderBottom: "2px solid #008CD7",
                borderRadius: 0,
                boxShadow: "none",
                maxHeight: "250px",
                overflow: "auto",
                color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
              },
            },
          }}
          ref={spanRef}
        >
          <MenuItem value="" disabled>
            Select a time period
          </MenuItem>
          {timePeriodOptions.map((period) => (
            <MenuItem
              key={period}
              value={period}
              onClick={(event) => handleMenuItemClick(event, period)}
            >
              {period}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ padding: "20px" }}>
          <DateRange
            editableDateInputs={true}
            onChange={handleDateChange}
            moveRangeOnFirstSelection={false}
            ranges={customDateRange}
          />
          <Button
            onClick={handleCustomDateConfirm}
            color="primary"
            disabled={!isDateRangeConfirmed}
          >
            Confirm
          </Button>
        </div>
      </Popover>
    </div>
  );
}

export default Year;

{
  /*<select  name="yearSelect" id="yearSelect"
         sx={{ marginTop:'9px',broderRadius:'0px'}}
        >
 
            <option sx={{backgroundcolor:"#000000"}} value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="this_week">This Week</option>
            <option value="last_week">Last Week</option>
            <option value="this_month">This Month</option>
            <option value="last_month">Last Month</option>
            <option value="this_year">This Year</option>
            <option value="last_year">Last Year</option>
            <option value="last_24_hours">Last 24 hours</option>
            <option value="last_7_days">Last 7 days</option>
            <option value="last_30_days">Last 30 days</option>
            <option value="custom">Custom</option>
        </select> */
}

/*
 
MenuItemProps:{
                    sx:{
                        bgcolor:'pink',
                    }
 
                }
 
 
 
 
 
        <ThemeProvider
            theme={createTheme({
                palette: { primary: { main: "#d1005e" } },
                components: {
                MuiMenuItem: {
                    styleOverrides: {
                    root: {
                        backgroundColor: "var(--)",
                        "&.Mui-selected": {
                        backgroundColor: "green",
                        "&.Mui-focusVisible": { background: "orange" }
                        }
                    }
                    }
                }
                }
            })}
        >
            <Select
            sx={{border:0,
                width:'122.35px',
                height: '40px',
                bgcolor:'var(--SecondaryBackground)',
                color:'var(--GreyVariation_2)',
                fontSize:'12px',
                fontFamily:'Roboto',
                fontWeight:400,
                textAlign:'left',
                borderRadius:0,
                marginRight:'16px',
                '& .MuiOutlinedInput-notchedOutline ': {
                    width:'122.35px',
                    height:'40px',
                    borderRadius: '0px',
                    //background:'var(--GreenBaseColor)',
                    border:0,
                    padding:0
                },
                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
                    border:0,
                }
            }}
            // MenuProps={{
            //     sx:{
            //         "&&.Mui-selected": {
            //             backgroundColor: "pink" ,
            //         }
            //     },
            //     PaperProps:{
            //         sx:{
            //             bgcolor:'#C1C1C1',
            //             borderBottom:'2px solid #008CD7',
            //             borderRadius:0,
            //             boxShadow:'none',
            //             maxHeight:'250px',
            //             overflow:'auto',
            //             color:'#3C3C3C',
                       
            //         }
            //     },
               
            // }}
           
            >
                            {timePeriod.map((period) => {
                                return <MenuItem sx={{fontSize:'12px', fontFamily:'Roboto',fontWeight:400,'&.MuiMenuItem-root': {justifyContent: 'flex-start'}}} value={period}>{period}</MenuItem>
                            })}
 
            </Select>
        </ThemeProvider>
       
    );
}
*/

/* <Select
            sx={{border:0,
                width:'122.35px',
                height: '40px',
                bgcolor:'var(--SecondaryBackground)',
                color:'var(--GreyVariation_2)',
                fontSize:'12px',
                fontFamily:'Roboto',
                fontWeight:400,
                textAlign:'left',
                borderRadius:0,
                marginRight:'16px',
                '& .MuiOutlinedInput-notchedOutline ': {
                    width:'122.35px',
                    height:'40px',
                    borderRadius: '0px',
                    //background:'var(--GreenBaseColor)',
                    border:0,
                    padding:0
                },
                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
                    border:0,
                },
                '& MuiButtonBase-root.Mui-selected':{
                    background:"pink"
                }
            }}
            MenuProps={{
                PaperProps:{
                    sx:{
                        bgcolor:'#C1C1C1',
                        borderBottom:'2px solid #008CD7',
                        borderRadius:0,
                        boxShadow:'none',
                        maxHeight:'250px',
                        overflow:'auto',
                        color:'#3C3C3C',
                        "&.Mui-hover":{
                            bgcolor:"pink"
                        }
                       
                    }
                },
                ButtonProps:{
                    sx:{
                        bgcolor:'pink',
                    }
 
                }
               
            }}
            >
                            {timePeriod.map((period) => {
                                return <MenuItem sx={{fontSize:'12px', fontFamily:'Roboto',fontWeight:400,}} value={period}>{period}</MenuItem>
                            })}
 
            </Select>
        */

/*// <ThemeProvider
        //     theme={createTheme({
        //         //palette: { primary: { main: "#d1005e" } },
        //         components: {
        //          MuiMenuItem: {
        //              styleOverrides: {
        //                 root: {
        //                 //backgroundColor: ,
        //                 "&.Mui-selected": {
        //                 backgroundColor: "green",
        //                 "&.Mui-focusVisible": { background: "orange" }
        //                 }
        //             }
        //             }
        //         },
        //         MuiPaper:{
        //             styleOverrides:{
        //                 root:{
        //                     background:"var(--AmberBaseColor)"
        //                 }
        //             }
        //         }
        //         }
        //     })}
        // >
 
 
                //</ThemeProvider>
 
       
       
        */
